import { maybe } from '@passionware/monads';
import {
  appScopeUtils,
  type AppScopeIdentity
} from 'v5/core/app-scope/appScope.types';
import { FeatureFlagSet } from 'v5/api/enterprise-feature-flag/enterprise-feature-flag.api';

/** The server's flag names for a scope: org-wide ones at the organization, the workspace's own below it. */
export function selectNamesForScope(
  set: FeatureFlagSet,
  scope: AppScopeIdentity
): string[] {
  if (scope.level === 'organization') {
    return set.legacy;
  }

  const workspaceId = appScopeUtils.getWorkspaceId(scope);
  if (maybe.isAbsent(workspaceId)) {
    return [];
  }

  return set.byWorkspace[workspaceId] ?? [];
}
